import { ILogModel } from "../interfaces/ILogModel";
import { ISolicitudEquipoModel } from "../interfaces/solicitud/ISolicitudEquipoModel";
import { DocumentacionRequeridaModel } from "./DocumentacionRequeridaModel";

export class EquipoDialogModel {
    equipo: EquipoModel;
    documentacionRequerida: DocumentacionRequeridaModel[];
    enableEdit: boolean;
    
    constructor(){
        this.equipo = new EquipoModel();
        this.documentacionRequerida = new Array<DocumentacionRequeridaModel>();
        this.enableEdit = true;
    }
}

export class EquipoModel implements ISolicitudEquipoModel {
    idSolicitud: number;
    codigoSolicitud: string;
    idSolicitudEquipo: number;

    equipo: string;

    marca : string;
    
    modelo : string;

    serie : string;

    idEstado: number;
    estado: string;
    documentos: Array<DocumentacionRequeridaModel>;
    documentosRequeridos: Array<DocumentacionRequeridaModel>;
    comentarios: string;
    
    documentosRevisados: number;
    enableEdit: boolean;
    logs: ILogModel[] = [];
    completado: boolean;
    
    constructor(){
        this.idSolicitud = 0;
        this.codigoSolicitud = '';
        this.idSolicitudEquipo = 0;
        // this._tipo = '';
        this.equipo = '';
        this.marca = '';
        this.modelo = '';
        this.serie = '';
        this.idEstado = 0;
        this.estado = '';
        this.documentos = new Array<DocumentacionRequeridaModel>();
        this.documentosRequeridos = new Array<DocumentacionRequeridaModel>();
        this.comentarios = '';
        this.enableEdit = true;
        this.documentosRevisados = 0;
        this.completado = false;
    }

    EsValido(): boolean {
        return (
        // this._tipo !== '' &&
        this.marca !== '' &&
        this.modelo !== '' &&
        this.serie !== '');
    }
}